module.exports = __webpack_public_path__ + "static/media/tools-solid.f0f5c9a2.svg";